import { render, staticRenderFns } from "./showcase-facets.vue?vue&type=template&id=4c0b7a58&"
import script from "./showcase-facets.ts?vue&type=script&lang=ts&"
export * from "./showcase-facets.ts?vue&type=script&lang=ts&"
import style0 from "./showcase-facets.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports